import { StyleSheet } from 'react-native';

export const UnvalidatedStyles = {
  systemMessageIconSize: 16,
};

export const Styles = StyleSheet.create({
  // Note(fant): desired radius: 9px (but 1px border makes that 9+1px)
  stackedUserImage: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: 'white',
    overflow: 'hidden',
  },
  stackedUserImageSmall: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: 'white',
    overflow: 'hidden',
  },
  stackedUserOverlap: {
    marginLeft: -7,
  },

  stackedUserOverlapSmall: {
    marginLeft: -4,
  },

  systemMessageIcon: {
    width: UnvalidatedStyles.systemMessageIconSize,
    height: UnvalidatedStyles.systemMessageIconSize,
    borderRadius: UnvalidatedStyles.systemMessageIconSize / 2,
    overflow: 'hidden',
  },
});
